module.exports = __webpack_public_path__ + "img/404.bd195dd6.png";